<div class="wrapper">
	<img *ngIf="isPaid() else volunteer" src="assets/images/statuses/paid.svg"/>

	<ng-template #volunteer>
		<img src="assets/images/statuses/nonpaid.svg"/>
	</ng-template>
</div>